import loadable from '@loadable/component'

import { FeedProps } from '@tribeplatform/react-components/Feed'
import { I18nShape } from '@tribeplatform/react-components/i18n'
import { RegisteredFeedBlock as DumbRegisteredFeedBlock } from '@tribeplatform/react-slate-kit/blocks/registered'
import { RegisteredBlock } from '@tribeplatform/react-slate-kit/types'

const Component = loadable(() => import('./Block'), {
  resolveComponent: m => m.FeedBlock,
})

export const RegisteredFeedBlocks = (
  intl: I18nShape,
): RegisteredBlock<FeedProps> => ({
  recommendedName: DumbRegisteredFeedBlock(intl).recommendedName,
  Component,
  config: DumbRegisteredFeedBlock(intl).config,
})
